import React, { useState } from "react";

const TabsContainer = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);

  // Ensure children is always an array
  const childrenArray = React.Children.toArray(children);

  return (
    <div className="tabs-container">
      <div className="tabs-header">
        {childrenArray.map((child, index) => (
          <button
            key={index}
            className={`tab-button ${activeTab === index ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {child.props.label}
          </button>
        ))}
      </div>
      <div className="tab-content">{childrenArray[activeTab]}</div>
    </div>
  );
};

const Tab = ({ children, label }) => {
  return <div className="tab-pane">{children}</div>;
};

export { TabsContainer, Tab };
